import { _ as _define_property } from "@swc/helpers/_/_define_property";
export class RemainingCreditReportEntryModel {
    static fromDTO(dto) {
        return new RemainingCreditReportEntryModel(dto);
    }
    id() {
        return this.data.id;
    }
    relationshipId() {
        return this.data.relationshipId;
    }
    vendorId() {
        return this.data.vendorId;
    }
    customerId() {
        return this.data.customerId;
    }
    agreementName() {
        return this.data.agreementName;
    }
    customerName() {
        return this.data.customerName;
    }
    serviceName() {
        return this.data.serviceName;
    }
    credit() {
        return this.data.credit;
    }
    rawCredit() {
        return this.data.rawCredit;
    }
    archived() {
        return this.data.archived;
    }
    constructor(data){
        _define_property(this, "data", void 0);
        this.data = data;
    }
}
